import { ANALYTICS_EVENTS } from '../../events'
import createAnalyticsStatic, { EventProps } from '../createAnalyticsEvent'

export interface StockTypeSelectedProps extends EventProps {
    type: string
}

/**
 * @event stock_type_selected
 * @description Emitted when the user selects the stock type filter (ETFs or Stocks).
 */
export const StockTypeSelectedAnalytics = createAnalyticsStatic<StockTypeSelectedProps>(
    ANALYTICS_EVENTS.FIND_STOCKS.STOCK_TYPE_SELECTED,
)

export default StockTypeSelectedAnalytics
